import { type paths } from 'api/playerPayback/api'
import { useAccessTokenContext } from 'contexts/AccessTokenContext'
import { Fetcher, type TypedFetch } from 'openapi-typescript-fetch'

const getHeaders = (disableAuth: boolean, token: string) => {
  if (disableAuth) {
    return undefined
  }

  return {
    Authorization: `Bearer ${token}`,
  }
}

export const useTypedApiClient = <
  PathT extends Extract<keyof paths, string>,
  MethodT extends Extract<keyof paths[PathT], string>,
>({
  path,
  method,
  disableAuth = false,
}: {
  path: PathT
  method: MethodT
  disableAuth?: boolean
}): TypedFetch<paths[PathT][MethodT]> => {
  const { accessToken } = useAccessTokenContext()
  const fetcher = Fetcher.for<paths>()

  fetcher.configure({
    baseUrl: import.meta.env.VITE_LE_CONNECT_API_BASE_URL,
    init: {
      headers: getHeaders(disableAuth, accessToken ?? ''),
    },
  })
  const create = fetcher.path(path).method(method)
    .create as unknown as () => TypedFetch<paths[PathT][MethodT]>
  return create()
}
